<template>
  <div class="UserManage">
    <b-card
      header="사용자관리"
      style="max-width: 50rem; margin: auto; margin-top: 3vh;"
      class="mb-2"
      align="left"
    >
      <div class="row">
        <div
          class="col-md-6 col-xl-3"
          v-for="stats in statsCards"
          :key="stats.title"
        >
          <stats-card>
            <div
              class="icon-big text-center"
              :class="`icon-${stats.type}`"
              slot="header"
            >
              <i :class="stats.icon"></i>
            </div>
            <div class="numbers" slot="content">
              <p>{{ stats.title }}</p>
              {{ stats.value }}
            </div>
            <div class="stats" slot="footer">
              <i :class="stats.footerIcon"></i> {{ stats.footerText }}
            </div>
          </stats-card>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <chart-card
            title="사용 기능 추이"
            ref="chart1"
            id="chart1"
            sub-title="24 Hours performance"
            :chart-data="usersChart.data"
            :chart-options="usersChart.options"
          >
            <span slot="footer">
              <i class="fa fa-sync"></i> 로그인 이용자 기준
            </span>
            <div slot="legend">
              <i class="fa fa-circle text-info"></i> 게시판
              <i class="fa fa-circle text-warning"></i> 개인공간
              <i class="fa fa-circle text-danger"></i> 지식창고
              <i class="fa fa-circle text-success"></i> 블로그
            </div>
          </chart-card>
        </div>
      </div>

      <b-form-group id="to-do-input">
        <b-container>
          <b-row>
            <b-col sm="6" class="my-1">
              <b-form-group
                label="Filter"
                label-for="filter-input"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="search"
                    placeholder="Type to Search"
                  ></b-form-input>

                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''"
                      >Clear</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col sm="6" class="my-1">
              <b-form-group
                label="Filter On"
                description="Leave all unchecked to filter on all data"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
                v-slot="{ ariaDescribedby }"
              >
                <b-form-checkbox-group
                  v-model="filterOn"
                  :aria-describedby="ariaDescribedby"
                  class="mt-1"
                >
                  <b-form-checkbox value="id">Id</b-form-checkbox>
                  <b-form-checkbox value="title">Title</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
            <b-col sm="6" class="my-1" align="start">
              <v-icon v-b-tooltip.hover title="Add row" @click="addRow()"
                >mdi-plus</v-icon
              >
              <v-icon
                v-b-tooltip.hover
                title="SelectAll/Deselect"
                @click="SelectAllRows"
                >mdi-select-all</v-icon
              >
              <!-- <v-icon @click="allEdit(selected)">mdi-pencil</v-icon> -->
              <v-icon
                v-b-tooltip.hover
                title="Save"
                @click="allSave(selected)"
                :disabled="saveOnHidden"
                >mdi-content-save</v-icon
              >
              <v-icon v-b-tooltip.hover title="Cancel" @click="allCancel()"
                >mdi-cancel</v-icon
              >
              <v-icon
                v-b-tooltip.hover
                title="Delete"
                @click="allRowDelete(selected)"
                :disabled="deleteOnHidden"
                >mdi-delete</v-icon
              >
              <!-- <b-button class="mr-1" variant="outline-primary" size="sm" @click="SelectAllRows">Select/Clear</b-button> -->
              <!-- <b-button class="mr-1" variant="outline-primary" size="sm" @click="allRowDelete(selected)">Delete</b-button> -->
            </b-col>
            <b-col sm="6" class="my-1" align="end">
              <b-button-group rounded mandatory>
                <b-button size="sm" @click="perPage = 10"> 10 </b-button>
                <b-button size="sm" @click="perPage = 20"> 20 </b-button>
                <b-button size="sm" @click="perPage = 30"> 30 </b-button>
              </b-button-group>
            </b-col>
          </b-row>
        </b-container>
      </b-form-group>

      <p></p>
      <b-table
        striped
        outlined
        responsive="sm"
        hover
        select-mode="multi"
        selectable
        @row-selected="onRowSelected"
        id="table"
        ref="selecttableTable"
        :items="results"
        :fields="fields"
        :options="options"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
      >
        <template #table-colgroup="scope">
          <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
          />
        </template>

        <template #cell(check)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>

        <template v-slot:cell(title)="row">
          <!-- <template v-if="edit2 === undefined">{{ row.item.title }}</template> -->
          <!-- <template v-for="i in edit2"> -->
          <b-form-input
            size="sm"
            v-if="showUp(row.item.id) == 'input'"
            v-model="row.item.title"
          />
          <template v-else>{{ row.item.title }}</template>
          <!-- </template> -->
        </template>

        <template v-slot:cell(memberType)="row">
          <b-dropdown v-if="showUp(row.item.id) == 'input'" variant="primary">
            <template #button-content>
              {{ row.item.memberType }}
            </template>
            <b-dropdown-item @click="setType(row, 1)">ADMIN</b-dropdown-item>
            <b-dropdown-item @click="setType(row, 2)">MANAGER</b-dropdown-item>
            <b-dropdown-item @click="setType(row, 3)">USER</b-dropdown-item>
          </b-dropdown>
          <template v-else>{{ row.item.memberType }}</template>
        </template>

        <template v-slot:cell(isAccountTryCount)="row">
          <template>
            {{ row.item.isAccountTryCount }}
          </template>
          <b-button @click="resetFailAccount(row.item)">초기화</b-button>
        </template>

        <template v-slot:cell(actions)="row">
          <b-button @click="pwReset(row.item)">초기화</b-button>
        </template>

        <template v-slot:cell(enabled)="row">
          <b-dropdown v-if="showUp(row.item.id) == 'input'" variant="primary">
            <template #button-content>
              {{ row.item.enabled }}
            </template>
            <b-dropdown-item @click="setEnabled(row)">{{
              row.item.enabled === true ? false : true
            }}</b-dropdown-item>
          </b-dropdown>
          <template v-else>{{ row.item.enabled }}</template>
        </template>

        <!-- <template #cell(actions)="row">
        <v-icon @click="rowEdit(row.item.id)">mdi-pencil</v-icon>
        <v-icon @click="rowSave(row.item.id, row.item.title, row.item.done)" :disabled="edit != row.item.id">mdi-content-save</v-icon>
        <v-icon @click="rowDeleted(row.item.id)">mdi-delete</v-icon>
      </template> -->
      </b-table>

      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
        align="center"
      ></b-pagination>

      <Spinner />
    </b-card>
    <Modal />
  </div>
</template>

<script>
import Spinner from "../components/Spinner";
import { init, setSnackBarInfo } from "../js/common_function";
import { StatsCard, ChartCard } from "../components/index";
import Chartist from "chartist";

export default {
  name: "list3",
  components: {
    StatsCard,
    ChartCard,
    Spinner,
  },
  data() {
    return {
      statsCards: this.$store.getters.isStatsCards,
      usersChart: {
        data: {
          labels: this.$store.getters.isChartLabels,
          series: this.$store.getters.isChartSeries,
        },
        options: {
          low: 0,
          high: this.$store.getters.isTopNum,
          showArea: true,
          height: "245px",
          axisX: {
            showLabel: true,
            showGrid: false,
          },
          axisY: {
            showLabel: true,
            showGrid: true,
            offset: 30,
            scaleMinSpace: 30,
          },
          lineSmooth: Chartist.Interpolation.simple({
            divisor: 3,
          }),
          showLine: true,
          showPoint: false,
        },
      },
      selected: [],
      totalRows: 1,
      filter: null,
      filterOn: [],
      currentPage: 1,
      perPage: 10,
      fields: [
        {
          key: "check",
          label: "",
          width: "5%",
        },
        {
          key: "nickname",
          label: "nickname",
          sortable: true,
          width: "7%",
        },
        {
          key: "username",
          label: "name",
          sortable: true,
        },
        {
          key: "memberType",
          label: "Type",
          sortable: true,
          variant: "danger",
          width: "13%",
        },
        {
          key: "finalLogin",
          label: "finalLogin",
          sortable: true,
          variant: "danger",
          width: "20%",
        },
        {
          key: "isAccountTryCount",
          label: "TryCount",
          sortable: true,
          variant: "danger",
          width: "13%",
        },
        {
          key: "enabled",
          label: "isEnabled",
          sortable: true,
          variant: "danger",
          width: "7%",
        },
        {
          key: "actions",
          label: "PW Reset",
          width: "13%",
        },
      ],
      results: [],
      newItems: [],
      options: {
        search: true,
        showColumns: true,
      },
      errors: [],
      securedApiCallSuccess: false,
      selectedID: null,
      useMast: false,
      newDone: false,
      member: {
        id: "",
        title: "",
        done: null,
      },
      loginMember: {
        username: "",
        password: "",
      },
      edit: null,
      edit2: [],
      saveOnHidden: true,
      deleteOnHidden: true,
      // itemLength: null,
    };
  },
  computed: {
    rows() {
      return this.results.length;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },

  methods: {
    addRow() {
      // console.log(document.getElementById("table"));
      // this.clicked = true;
      // var input = document.createElement("input");
      // input.setAttribute('type', 'text');
      // var parent = document.getElementById("table");
      // parent.appendChild(input);
      //
      // this.fetched_classf.push({
      //   check: "",
      //   id: "",
      //   title: "",
      //   done: false
      // })
      // this.terbesar = id_incremented
      this.results.push({
        nickname: "NEWBI",
      });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // Fetches posts when the component is created.
    onRowSelected(results) {
      // console.log(this);
      console.log(results);
      this.selected = results;
      this.deleteOnHidden = false;
      this.allEdit(results);
    },
    allRowDelete: function (selected) {
      if (selected.length != 0) {
        init().then(() => {
          this.$confirm({
            auth: true,
            message: "Are you sure?",
            button: {
              no: "No",
              yes: "Yes",
            },
            callback: (confirm, password) => {
              this.loginMember.username = localStorage.getItem("username");
              this.loginMember.password = password;

              this.$store
                .dispatch("MATCH_LOGIN", this.loginMember)
                .then((res) => {
                  if (confirm && res.data.data == true) {
                    this.$store
                      .dispatch("ALL_ROW_DELETE", selected)
                      .then(() => {
                        this.callAllListApi();
                      });
                  } else if (confirm && res.data.data == null) {
                    this.$store.commit(
                      "SET_SNACKBAR",
                      setSnackBarInfo("비밀번호가 틀립니다.")
                    );
                  }
                });
            },
          });
        });
      } else {
        this.$store.commit(
          "SET_SNACKBAR",
          setSnackBarInfo("삭제할 일정을 선택해주세요.")
        );
      }
    },
    allSave(results) {
      if (results.length != 0) {
        // console.log(results);
        // console.log(this.selected);
        // console.log(this);
        init().then(() => {
          this.$confirm({
            message: "Are you sure?",
            button: {
              no: "No",
              yes: "Yes",
            },
            callback: (confirm) => {
              if (confirm) {
                // this.member.id = id;
                // this.member.title = title;
                // this.member.done = done;
                this.$store.dispatch("ALL_UPDATE_USER", results).then(() => {
                  this.$store.commit(
                    "SET_SNACKBAR",
                    setSnackBarInfo("저장 완료.")
                  );

                  this.callAllUser();
                  this.allCancel();
                });
              }
            },
          });
        });
      } else {
        this.$store.commit(
          "SET_SNACKBAR",
          setSnackBarInfo("저장할 일정을 선택해주세요.")
        );
      }
    },
    resetFailAccount(row) {
      this.$confirm({
        message: "비밀번호 실패 횟수 초기화?",
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            // this.member.id = id;
            // this.member.title = title;
            // this.member.done = done;
            this.$store.dispatch("FAIL_ACCOUNT_RESET", row).then(() => {
              this.callAllUser();
              this.allCancel();
            });
          }
        },
      });
    },
    pwReset(row) {
      this.$confirm({
        message: "비밀번호 초기화?",
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            // this.member.id = id;
            // this.member.title = title;
            // this.member.done = done;
            this.$store.dispatch("PW_RESET", row).then(() => {
              this.callAllUser();
              this.allCancel();
            });
          }
        },
      });
    },
    allEdit(results) {
      const compare = [];
      results.map(function (value, key) {
        compare[key] = value;
      });
      this.edit2 = compare;
      // console.log("edit2 is ", this.edit2);
      this.saveOnHidden = false;
      // console.log(this.selected);
      // console.log(this);
    },
    allCancel() {
      this.edit2 = undefined;
      this.saveOnHidden = true;
      this.deleteOnHidden = true;
      this.$refs.selecttableTable.clearSelected();
    },

    setType(row, type) {
      switch (type) {
        case 1:
          row.item.memberType = "ADMIN";
          break;
        case 2:
          row.item.memberType = "MANAGER";
          break;
        case 3:
          row.item.memberType = "USER";
          break;
      }
    },
    setEnabled(row) {
      row.item.enabled = row.item.enabled !== true;
    },
    rowEdit(id) {
      this.edit = this.edit !== id ? id : null;
    },
    showUp(id) {
      let check;
      if (this.edit2 != undefined) {
        // console.log("id is", id);
        this.edit2.map(function (value, key) {
          // console.log("edit2 is ", value.id);
          if (id == value.id) {
            // console.log("input");
            check = "input";
          }
        });
        if (check === null) {
          check = "text";
        }
        return check;
      } else {
        // console.log("external text");
        return "text";
      }
    },

    SelectAllRows() {
      if (this.$refs.selecttableTable.selectedRows.length == 0) {
        this.saveOnHidden = false;
        this.deleteOnHidden = false;

        this.$refs.selecttableTable.selectAllRows();
      } else {
        this.saveOnHidden = true;
        this.deleteOnHidden = true;

        this.$refs.selecttableTable.clearSelected();
      }
    },

    callAllUser() {
      this.$store.commit("START_SPINNER");
      this.$axios({
        url: this.$config.baseUserMngURL + "/allList",
        method: "get",
        headers: {
          "token-key": localStorage.getItem("token-key"),
        },
      })
        .then((response) => {
          // console.log(response);
          this.results = response.data;
          this.securedApiCallSuccess = true;
          this.edit2 = undefined;
          this.$store.commit("END_SPINNER");
        })
        .catch((error) => {
          this.$store.commit("SET_SNACKBAR", setSnackBarInfo("서버 에러 발생"));

          this.errors.push(error);
          console.log(error);
          this.$store.commit("END_SPINNER");
        });
    },

    createToDo: function (event) {
      init().then(() => {
        event.preventDefault();
        if (!this.newItems.title) return; // To Do Item의 제목이 없으면 아무것도 안하고 리턴
        this.$axios({
          url: this.$config.baseToDoAppURL + "/newList",
          method: "post",
          data: {
            title: this.newItems.title,
          },
          headers: {
            "token-key": localStorage.getItem("token-key"),
          },
        })
          .then((response) => {
            this.$store.commit(
              "SET_SNACKBAR",
              setSnackBarInfo("일정 추가 성공")
            );

            this.callAllListApi();
            this.newItems = {};
          })
          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR",
              setSnackBarInfo("권한이 없습니다.")
            );

            console.log(error);
          });
      });
    },
    markDone: function (item) {
      init().then(() => {
        if (!item) return;
        if (item.done) this.newDone = true;
        else this.newDone = false;
        this.$axios({
          url: this.$config.baseToDoAppURL + "/updateList",
          method: "post",
          data: {
            id: item.id,
            done: this.newDone,
          },
          headers: {
            "token-key": localStorage.getItem("token-key"),
          },
        })
          // .then((response) => {
          //   // this.callAllListApi();
          // })
          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR",
              setSnackBarInfo("권한이 없습니다.")
            );

            console.log(error);
          });
      });
    },
  },
  async mounted() {
    this.$parent.$parent.$children.map(function (value, key) {
      if (value.$options._componentTag === "AppBar") {
        value.navTopBar = false;
      }
    });
    const path = this.$route.fullPath;
    // document.body.setAttribute("oncontextmenu", "return false");
    // document.body.setAttribute("onselectstart", "return false");
    // document.body.setAttribute("ondragstart", "return false");
    init(path).then(() => {
      this.callAllUser();
    });
  },
  // mounted() {
  //   this.$getInfo();
  //   this.callAllListApi();
  // }
};
</script>
